class OffcanvasMobileNavigator {
  constructor() {
    this.navButtons = document.querySelectorAll('.nav-mobile button');
    this.backButton = document.querySelector('.nav-mobile__back');

    function updateNav(id) {
      this.navItems = document.querySelectorAll('.nav-mobile__nav-item__link');
      this.navTitles = document.querySelectorAll('.nav-mobile__title');
      this.backButton = document.querySelector('.nav-mobile__back');

      // Show back button and set id to previous nav
      this.previousNav = document
        .querySelector(`nav#${id}`)
        .parentNode.closest('nav');
      if (this.previousNav !== null) {
        this.backButton.id = this.previousNav.id;
        this.backButton.classList.remove('d-none');
      } else {
        this.backButton.classList.add('d-none');
      }

      // hide all links except children of nav with matching id
      this.navItems.forEach((item) => {
        if (item.closest('nav').id !== id) {
          item.classList.add('d-none');
        } else {
          item.classList.remove('d-none');
        }
      });

      // hide all titles except children of nav with matching id
      this.navTitles.forEach((item) => {
        if (item.closest('nav').id !== id) {
          item.classList.add('d-none');
        } else {
          item.classList.remove('d-none');
        }
      });
    }

    this.navButtons.forEach((button) => {
      button.addEventListener('click', () => {
        updateNav(button.id);
      });
    });

    this.backButton.addEventListener('click', () => {
      updateNav(this.backButton.id);
    });
  }
}

// Initialise here
document.addEventListener(
  'DOMContentLoaded',
  () => new OffcanvasMobileNavigator()
);
